import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    flex-direction: column;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
`;

export const CollapsingWrapper = styled(Accordion)<{ open: boolean }>`
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    & > div:first-child {
        ${FONTS.H3};
        color: ${COLORS.TextPrimary};

        & > span {
            width: 48px;
            height: 48px;

            svg {
                circle {
                    stroke: ${COLORS.ButtonSecondary};
                    fill: ${COLORS.ButtonSecondary};
                }

                path {
                    stroke: ${COLORS.Control};
                }
            }
        }
    }

    & > div:last-child {
        overflow: ${p => p.open ? 'visible' : 'hidden'};

        & > div:first-child {
            margin: 0;
            display: none;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 12px 16px;
        border-radius: ${BorderRadius.componentRadius};

        & > div:first-child {
            ${FONTS.H5};

            & > span {
                width: 36px;
                height: 36px;
            }
        }
    }
`;

export const Title = styled.h3`
    margin: 0;
    ${FONTS.H3};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H5};
    }
`;

export const CollapsingContent = styled.div<{ isAccordion: boolean }>`
    flex-direction: column;
    width: 100%;
    ${({ isAccordion }) => isAccordion && css`
        margin-top: 16px;
    `}
`;
